// UMD-Wrapper der material-components-web.min.js in Kombination mit deinem Rollup-Build macht das kaputt
// -> im Layout <script src="/files/theme/src/js/lib/material-components-web.min.js"></script>
// import "./lib/material-components-web.min.js";
import "./modules/autosize";
import "./modules/header_animation.js";
import "./modules/misc.js";
import "./modules/material-comonents.js";
import "./modules/form.js";

import DoubleTapToGo from "./lib/doubleTapToGo.js";
// $('#nav_main').doubleTapToGo();
const instance = new DoubleTapToGo(document.querySelector("#nav_main"), {
  automatic: true,
  selectorClass: "doubletap",
});

// import "./lib/awesomplete.js";
// import "./module/form_validation.js";
// import "./module/form_conditional_fields.js";

[/Edg/, /Edge/].forEach((name) => {
  if (name.test(navigator.userAgent)) {
    document.documentElement.className += " edge";
    // alert('Hello Microsoft User!');
    console.log(navigator.userAgent);
  }
});

/**
 * window.load
 *
 */
// window.addEventListener('load', function() {
//     $('body').removeClass(' is-loading');

//     console.log('window - load - capture');
// }, true);
